import { Button, ButtonProps } from "@mui/material";
import React, { PropsWithChildren, ReactNode } from "react";
import {
  OUTLINEDBLACK,
  CONTAINEDBLACK,
  CONTAINED,
  OUTLINEDWHITE,
} from "src/types/types";
import CircularIndeterminate from "../Spinner";
export enum typeVar {
  Contained = "contained",
  ContainedBlack = "containedBlack",
  OutlinedBlack = "outlinedBlack",
  OutlinedWhite = "outlinedWhite",
  General = "general",
}
interface RButtonProps extends ButtonProps {
  endIcon?: ReactNode;
  startIcon?: ReactNode;
  typeVar: typeVar;
  width?: number;
  height?: number;
  name: string;
  isSubmitting?: boolean;
  blackButton?: boolean;
  onEvent?: () => void;
  marginTop?: number;
  disabled?: boolean;
}

const RButton: React.FC<PropsWithChildren<RButtonProps>> = ({
  typeVar,
  width,
  endIcon,
  startIcon,
  name,
  height,
  isSubmitting,
  blackButton,
  onEvent,
  marginTop,
  disabled,
  sx,
  ...props
}) => {
  return (
    <Button
      {...props}
      endIcon={endIcon}
      type="submit"
      onClick={onEvent}
      disabled={isSubmitting || disabled}
      size={props.size}
      sx={
        typeVar === CONTAINED
          ? {
              width: `${width}px`,
              height: `${height}px`,
              borderRadius: "30px",
              backgroundImage:
                "linear-gradient(90deg, rgba(254,189,47,1) 0%, rgba(253,29,29,1) 49%, rgba(23,40,155,1) 100%)",
              color: "#fff",
              border: "1px solid white",
              "&:hover": {
                backgroundImage:
                "linear-gradient(90deg, rgba(23,40,155,1) 0%, rgba(253,29,29,1) 49%, rgba(254,189,47,1) 100%)",
              },
            }
          : typeVar === CONTAINEDBLACK
          ? {
              width: `${width}px`,
              height: `${height}px`,
              borderRadius: "30px",
              backgroundColor: "#000",
              color: "#fff",
              marginTop: `${marginTop}px`,
              minWidth: null,
              "&:hover": {
                color: "#000",
                backgroundColor: "#fff",
              },
            }
          : typeVar === OUTLINEDBLACK
          ? {
              width: `${width}px`,
              borderRadius: "30px",
              height: `${height}px`,
              color: "#000",
              marginTop: `${marginTop}px`,
              border: "2px solid #000",
              "&:hover": {
                border: "2px solid #000",
                backgroundColor: "#000",
                color: "#FFF",
              },
            }
          : typeVar === OUTLINEDWHITE
          ? {
              width: `${width}px`,
              borderRadius: "30px",
              height: `${height}px`,
              color: "#FFF",
              marginTop: `${marginTop}px`,
              border: "1px solid #FFF",
            }
          : {
              width: `${width}px`,
              borderRadius: "30px",
              height: `${height}px`,
              color: "#000",
              marginTop: `${marginTop}px`,
              border: "2px solid transparent",
              "&:hover": {
                border: "2px solid #000",
              },
            }
      }
      startIcon={startIcon}
    >
      {isSubmitting ? <CircularIndeterminate size={25} /> : name}
    </Button>
  );
};

export default RButton;
